"use strict";
/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CellMultiText = void 0;
const react_1 = __importDefault(require("react"));
const cell_enhance_text_1 = require("../cell_enhance_text");
const CellMultiText = (props) => {
    const { text, cellClassName, cellStyle } = props;
    if (!text) {
        return null;
    }
    const multiTexts = text.split(/\n/g);
    return (react_1.default.createElement("div", { className: cellClassName, style: cellStyle }, multiTexts.map((multiText, index) => (react_1.default.createElement(cell_enhance_text_1.CellEnhanceText, { key: index, text: multiText })))));
};
exports.CellMultiText = CellMultiText;
